import { TOGGLE_HEADER, TOGGLE_RIGHT_PANE, TOGGLE_LEFT_NAV } from "../constants/ActionTypes";

var initialState = {
	showHeader: false,
	showRightPane: false,
	showLeftNav: false,
};

export default function(state = initialState, action) {
	// console.log(state, action);
	switch (action.type) {
	case TOGGLE_HEADER:
		return { ...state, showHeader: !state.showHeader };
	case TOGGLE_RIGHT_PANE:
		return { ...state, showRightPane: !state.showRightPane };
	case TOGGLE_LEFT_NAV:
		return { ...state, showLeftNav: !state.showLeftNav };
	default:
		return state;
	}
}



/** WEBPACK FOOTER **
 ** ./src/scripts/reducers/moduleToggler.js
 **/